import React, { PropsWithChildren } from 'react';
import { BuilderComponent, BuilderComponentProps } from '@mnz/builder';
import StyledComponent, { ResponsiveStyle } from '../core/StyledComponent';

interface ContainerProps extends PropsWithChildren<BuilderComponentProps>, ResponsiveStyle {}

export const Container: BuilderComponent<ContainerProps> = ({ children, ...props }) => {
    return <StyledComponent {...props}>{children}</StyledComponent>;
};

Container.defaultProps = {};
Container.settings = {
    displayName: 'Container',
    rules: {
        canDrag: () => false,
    },
};
